import React, { useState, useContext } from 'react';
import { Button, Modal, Typography } from 'antd';
import { IconMapPin, IconRefresh, IconSearchOff } from '@tabler/icons-react';
import ChangeLocationContent from './ChangeLocationContent';
import { LocationContext } from '../LocationContext';
import noProductsImg from '../assets/img/no-products.png';
import '../css/EmptyState.css';

const { Title, Text } = Typography;

const EmptyState = ({ 
    title = "No products available in your location", 
    description = "Try expanding your search radius or changing your location to find products near you.",
    onRefresh 
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { setSelectedAddress, setCityName, setLatitude, setLongitude, setRadius } = useContext(LocationContext);

    const handleApplyLocation = (data) => {
        if (data.lat && data.lng) {
            setLatitude(data.lat);
            setLongitude(data.lng);
            setRadius(data.radius || 7);
            setSelectedAddress(data.address);
            setCityName(data.city || "");
            setIsModalOpen(false);
            if (onRefresh) onRefresh();
        }
    };

    const handleResetLocation = () => {
        setSelectedAddress("");
        setCityName("");
        setLatitude(null);
        setLongitude(null);
        setRadius(7);
        setIsModalOpen(false);
    };

    return (
        <div className="empty-state-container">
            <div className="empty-state-card">
                <div className="empty-state-illustration">
                    <img src={noProductsImg} alt="No products" className="illustration-img" />
                    <div className="illustration-pulse"></div>
                </div>
                
                <Title level={3} className="empty-state-title">{title}</Title>
                <Text className="empty-state-desc">{description}</Text>
                
                <div className="empty-state-actions">
                    <Button 
                        type="primary" 
                        icon={<IconMapPin size={18} />} 
                        onClick={() => setIsModalOpen(true)}
                        className="change-location-btn"
                        size="large"
                    >
                        Change Location
                    </Button>
                    
                    {onRefresh && (
                        <Button 
                            icon={<IconRefresh size={18} />} 
                            onClick={onRefresh}
                            className="refresh-btn"
                            size="large"
                        >
                            Refresh
                        </Button>
                    )}
                </div>

                <div className="empty-state-suggestions">
                    <Text type="secondary" className="suggestion-text">
                        <IconSearchOff size={14} style={{ marginRight: 4 }} />
                        Try another category or broaden your search area
                    </Text>
                </div>
            </div>

            <Modal
                title={null}
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
                width={650}
                centered
                destroyOnClose
                className="location-modal-premium"
            >
                <ChangeLocationContent 
                    onApply={handleApplyLocation}
                    onReset={handleResetLocation}
                    height="320px"
                />
            </Modal>
        </div>
    );
};

export default EmptyState;
